import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../config';

export const blogApi = createApi({
    reducerPath: 'blogApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${getApiUrl()}/blog`,
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json');
            return headers;
        },
    }),
    tagTypes: ['BlogPost', 'BlogCategory', 'BlogTag'],
    endpoints: (builder) => ({
        // Blog yazılarını getir (sayfalama ve filtreleme ile)
        getBlogPosts: builder.query({
            query: ({ page = 1, per_page = 6, category, search } = {}) => {
                const params = new URLSearchParams({
                    page: page.toString(),
                    per_page: per_page.toString(),
                });
                
                if (category && category !== 'all') {
                    params.append('category', category);
                }
                
                if (search) {
                    params.append('search', search);
                }
                
                return `?${params.toString()}`;
            },
            providesTags: (result) =>
                result?.data?.posts
                    ? [
                        ...result.data.posts.map(({ id }) => ({ type: 'BlogPost', id })),
                        { type: 'BlogPost', id: 'LIST' },
                    ]
                    : [{ type: 'BlogPost', id: 'LIST' }],
        }),

        // Slug'a göre blog yazısını getir (SEO için en önemli endpoint)
        getBlogPostBySlug: builder.query({
            query: (slug) => `${slug}`,
            providesTags: (result, error, slug) => [
                { type: 'BlogPost', id: slug },
            ],
        }),

        // Blog kategorilerini getir
        getBlogCategories: builder.query({
            query: () => 'categories',
            providesTags: [{ type: 'BlogCategory', id: 'LIST' }],
        }),

        // Popüler etiketleri getir (SEO için)
        getPopularTags: builder.query({
            query: (limit = 10) => `tags?limit=${limit}`,
            providesTags: [{ type: 'BlogTag', id: 'LIST' }],
        }),

        // Blog yazılarında arama yap (SEO için internal search)
        searchBlogPosts: builder.query({
            query: ({ q, page = 1, per_page = 6 }) => {
                const params = new URLSearchParams({
                    q,
                    page: page.toString(),
                    per_page: per_page.toString(),
                });
                return `search?${params.toString()}`;
            },
            providesTags: [{ type: 'BlogPost', id: 'SEARCH' }],
        }),
    }),
});

// Export hooks for usage in functional components (sadece okuma işlemleri)
export const {
    useGetBlogPostsQuery,
    useGetBlogPostBySlugQuery,
    useGetBlogCategoriesQuery,
    useGetPopularTagsQuery,
    useSearchBlogPostsQuery,
    useLazyGetBlogPostsQuery,
    useLazySearchBlogPostsQuery,
} = blogApi; 